import { all, fork } from 'redux-saga/effects';
import authSaga from './authSaga';
import marketSaga from './marketSaga';
import watchlistSaga from './watchlistSaga';
import portfolioRootSaga from './portfolioSaga';
import orderRootSaga from './orderSaga';
import searchSaga from './searchSaga';
import { addOrderSaga } from './addorderSaga';
// ── Socket.IO bridge: streams live ticks from Node into Redux. ──
// Runs for the lifetime of the app. REST polling in the other sagas
// becomes a fallback that activates only when the socket is down.
import marketSocketSaga from './marketSocketSaga';

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(marketSaga),
    watchlistSaga(),
    portfolioRootSaga(),
    orderRootSaga(),
    searchSaga(),
    addOrderSaga(),
    marketSocketSaga(),
  ]);
}